<template>
  <div>
    <section class="container">
      <ul v-if="details != ''">
        <li class="disBlock">
          <label>项目：</label>
          <p>{{ details.project_name }}</p>
        </li>
        <li class="disBlock">
          <label>员工：</label>
          <p>{{ details.user_name }}</p>
        </li>
        <li>
          <label>计薪方式：</label>
          <p v-show="details.count_type == 1">单价</p>
          <p v-show="details.count_type == 2">时薪</p>
          <p v-show="details.count_type == 3">底薪</p>
          <p v-show="details.count_type == 4">计件</p>
        </li>
        <li v-show="details.count_type == 1 || details.count_type == 2">
          <label>工单日期：</label>
          <p>{{ details.work_date }}</p>
        </li>
        <li v-show="details.count_type == 3 || details.count_type == 4">
          <label>出勤日期：</label>
          <p>{{ details.work_date }}</p>
        </li>
        <li v-show="details.count_type == 1">
          <label>工单数量：</label>
          <p>{{ details.work_count }}</p>
        </li>
        <li v-show="details.count_type == 2">
          <label>工作时长：</label>
          <p>{{ details.work_time }}</p>
        </li>
        <li v-show="details.count_type == 4">
          <label>件数：</label>
          <p>{{ details.work_piece }}</p>
        </li>
        <li>
          <label>预计结算：</label>
          <p>{{ Number(details.checked_guard) + "元" }}</p>
        </li>
        <li>
          <label>提交时间：</label>
          <p>{{ details.update_time }}</p>
        </li>
        <li class="disBlock">
          <label>附件：</label>
          <viewer :images="details.images_url">
            <img
              class="imgStyle"
              v-for="src in details.images_url"
              :src="src.url"
              :key="src.id"
            />
          </viewer>
        </li>
      </ul>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      details: {}
    };
  },
  mounted() {
    if (this.detailsVal != undefined) {
      this.details = this.detailsVal;
    }
    console.log(this.detailsVal);
  },
  props: {
    detailsVal: {}
  },
  watch: {
    detailsVal() {
      this.details = this.detailsVal;
      console.log(this.detailsVal);
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  margin: 30px 2%;
  > ul {
    > li {
      display: inline-block;
      min-width: 33%;
      img {
        width: 200px;
        height: 200px;
        object-fit: cover;
        vertical-align: top;
      }
      p,
      label {
        display: inline-block;
        font-size: 14px;
        line-height: 24px;
        vertical-align: top;
      }
    }
    .disBlock {
      display: block;
    }
  }
}
</style>
